import React, { useState, useEffect } from 'react';
import firebase from '../utils/Firebase';
import { useAuth0 } from "@auth0/auth0-react";
import { Link } from 'react-router-dom';


import TopHeader from "../components/TopHeader";
import { notification } from 'antd';
import 'antd/dist/antd.css';
import backBtn from "../img/back_btn.svg";



// vendors list 
const useItems = () => {
    const [items, setItems] = useState([]); //useState() hook, sets initial state to an empty array

    useEffect(() => {
        firebase
            .firestore() //access firestore
            .collection("vendors") //access "items" collection
            .onSnapshot(snapshot => {
                //You can "listen" to a document with the onSnapshot() method.
                const listItems = snapshot.docs.map(doc => ({
                    //map each document into snapshot
                    key: doc.id, //id and data pushed into items array
                    ...doc.data() //spread operator merges data to id.
                }));
                setItems(listItems); //items is equal to listItems
            });
    }, []);
    return items;
};

// vendors list 


const AddPromo = () => {

    const [applied_for, setapplied_for] = useState("");
    const [code, setcode] = useState("");
    const [description, setdescription] = useState("");
    const [promo_img, setpromo_img] = useState("");
    const [submittedBy, setsubmittedBy] = useState("");
    const [validTill, setvalidTill] = useState("");
    const [vendor_name, setvendor_name] = useState("");

    const { user, loginWithPopup, logout } = useAuth0();
    const onSubmit = e => {
        /* 
        preventDefault is important because it
        prevents the whole page from reloading
        */

        e.preventDefault()
        firebase
            .firestore()
            .collection("promocodes")
            .add({
                applied_for,
                code,
                description,
                promo_img,
                submittedBy,
                validTill,
                vendor_name

            })
            //.then will reset the form to nothing
            .then(() =>
                setapplied_for(""),
                setcode(""),
                setdescription(""),
                setpromo_img(""),
                setsubmittedBy(""),
                setvalidTill("")
            );
        openNotification(vendor_name);

    }

    const openNotification = (vendor_name) => {
        notification.open({
            message: 'Promo was created successfully !',
            description:
                'Vendor Name : ' + vendor_name
        });
    };
    const listItem = useItems();


    return (<>

        <Link to="/"><TopHeader pageTitle="Add Promo Code" app_logo={backBtn} /></Link>
        {user ?
            <div className="container mt-100">
                <div className="row">
                    <div className="col-sm-6 mt-4 mx-auto card p-5">
                        <form onSubmit={onSubmit}>
                            <label className="mb-1">Select Vendor*</label>
                            <select name="cars" className="form-control mb-3 mt-0" onChange={e => setvendor_name(e.currentTarget.value)} required>
                                <option value="" disabled selected>-Select Vendor-</option>

                                {listItem
                                    ? listItem.map((item) =>
                                        <option key={item.key} value={item.vendor_name}>{item.vendor_name}</option>
                                    ) : ''}

                            </select>

                            <label className="mb-1">Code*</label>
                            <input className="mb-3 mt-0 form-control" required placeholder="Enter Code"
                                value={code}
                                name="code"
                                onChange={e => setcode(e.currentTarget.value)}
                                type="text"
                            />
                            <label className="mb-1">Applied For*</label>
                            <input className="mb-3 mt-0 form-control" required placeholder="applied_for"
                                value={applied_for}
                                name="applied_for"
                                onChange={e => setapplied_for(e.currentTarget.value)}
                                type="text"
                            />

                            <label className="mb-1">Description*</label>
                            <textarea className="mb-3 mt-0 form-control" required placeholder="description"
                                value={description}
                                name="description"
                                onChange={e => setdescription(e.currentTarget.value)}
                                type="text"
                            />

                            <label className="mb-1">Promo Image (if any)</label>

                            <input className="mb-3 mt-0 form-control" placeholder="promo_img"
                                value={promo_img}
                                name="promo_img"
                                onChange={e => setpromo_img(e.currentTarget.value)}
                                type="text"
                            />

                            <label className="mb-1">Validity Info</label>

                            <input className="mb-3 mt-0 form-control" placeholder="validTill"
                                value={validTill}
                                name="validTill"
                                onChange={e => setvalidTill(e.currentTarget.value)}
                                type="text"
                            />

                            <label className="mb-1">Submitted By</label>

                            <input className="mb-3 mt-0 form-control" placeholder="submittedBy"
                                value={submittedBy}
                                name="submittedBy"
                                onChange={e => setsubmittedBy(e.currentTarget.value)}
                                type="text"
                            />


                            <button style={{ width: "100%" }} className="btn btn-primary">Submit</button>
                            <button style={{ width: "100%" }} className="btn btn-outline-danger mt-2" onClick={() => logout()} >Logout</button>

                        </form>
                    </div>
                </div>
            </div>
            : <>
                <div className="container mt-5">
                    <div className="row text-center">
                        <div className="col-sm-6 mt-4 mx-auto card p-5">
                            <div className="my-auto"><img src="https://img.freepik.com/free-vector/mobile-login-concept-illustration_114360-83.jpg?size=338&ext=jpg" alt="" width="300px" /> </div>
                            <h4>You need to login first to access this page.</h4>
                            <button className="btn btn-primary" onClick={() => loginWithPopup()} >Login Now</button>
                        </div>
                    </div>
                </div>

            </>
        }

    </>);
}

export default AddPromo;